<div class="flex z-10 flex-col mt-2 rounded-md bg-white p-2 shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
  <div class="flex flex-col items-start">
    @for (row of algolia.getIndexSelectRows(); track row._id) {
      <button
        (click)="setIndex(row._id)"
        class="font-medium text-gray-500 px-4 py-2 text-sm"
        [class.text-gray-900]="algolia.observeIsIndexActive(row._id) | async"
      >
        {{ row.displayValue | i18n }}
      </button>
    }
  </div>
</div>
